import { action } from 'satcheljs';

/**
 * Action to mutate showDialogMessageFlag to render PeoplePickerDialog
 * @param showDialogMessageFlag - whether to show or hide PeoplePicker dialog
 */
export const showSharedFolderPeoplePickerDialog = action(
    'showAddSharedFolderDialog',
    (showDialogMessageFlag: boolean) => ({
        showDialogMessageFlag,
    })
);
